import { BaseViewStore } from 'core/stores';
import { makeObservable, observable } from 'mobx';
import _ from 'lodash';

class ScheduledJobLogDetailsViewStore extends BaseViewStore {
	@observable data = null;

	constructor(rootStore, { modalParams }) {
		super(rootStore);
		makeObservable(this);
		this.data = modalParams.data;
	}

	copyToClipboard = (text) => {
		if (navigator.clipboard && window.isSecureContext) {
			navigator.clipboard.writeText(text);
			this.rootStore.notificationStore.success("Copied job identifier to clipboard.");
		}
	}
}

export default ScheduledJobLogDetailsViewStore;
